import { FieldHookConfig } from 'formik'
import React from 'react'
import { ApiFetch } from '../Api'
import { AsyncSelectField } from '../AsyncSelectField'

const UserSearchSelect: React.FC<FieldHookConfig<string>> = (props) => {

    let searchTimeoutRef: NodeJS.Timeout | null = null
    const searchUserID = (inputValue: string) => {
        return new Promise<{label:string, value:string}[]>(resolve => {
            if(inputValue.length < 3) {
                resolve([])
                return
            }
            if(searchTimeoutRef) clearTimeout(searchTimeoutRef)
            searchTimeoutRef = setTimeout(() => {
                resolve(
                    ApiFetch<{userID: string, name: string}[]>('User', { name: inputValue })
                        .then(result=>result.map((r)=>{ return { value: r.userID, label:r.name }}))
                )
            }, 600)
        })
    }
    return <AsyncSelectField {...props} loadOptions={searchUserID} noOptionsMessage={()=>'Enter name to search'} />
}

export default UserSearchSelect